import { Flex, View, Text } from "@aws-amplify/ui-react";
import CheckIcon from "./CheckIcon";

export default function StatusCheckComponent({label, isValid = true}) {
  return (
    <Flex>
      <View width="24px" height="24px" position="relative">
        <CheckIcon isValid={isValid} />
      </View>
      <Text
        fontFamily="Inter"
        fontSize="16px"
        fontWeight="400"
        color="rgba(48,64,80,1)"
        lineHeight="24px"
        children={label}
      ></Text>
    </Flex>
  );
}
